import { defineMessages } from "react-intl";
const messages = defineMessages({
    cancelButton: {
        id: "app.aiDiscoverability.customSubtopics.commuteRow.cancel",
        defaultMessage: "Cancel",
    },
    byLabel: {
        id: "app.aiDiscoverability.customSubtopics.commuteRow.byLabel",
        defaultMessage: "by",
    },
    toLabel: {
        id: "app.aiDiscoverability.customSubtopics.commuteRow.toLabel",
        defaultMessage: "to",
    },
    destinationPlaceholder: {
        id: "app.aiDiscoverability.customSubtopics.commuteRow.destinationPlaceholder",
        defaultMessage: "Enter landmarks or POI's such as: Bryant Park, Whole foods, etc",
    },
    publicTransit: {
        id: "app.aiDiscoverability.customSubtopics.commuteRow.publicTransit",
        defaultMessage: "Public transit (bus, train, etc)",
    },
    allPublicTransit: {
        id: "app.aiDiscoverability.customSubtopics.commuteRow.allPublicTransit",
        defaultMessage: "All public transit",
    },
    walking: {
        id: "app.aiDiscoverability.customSubtopics.commuteRow.walking",
        defaultMessage: "Walking",
    },
    biking: {
        id: "app.aiDiscoverability.customSubtopics.commuteRow.biking",
        defaultMessage: "Biking",
    },
    commuteDisplayFormat: {
        id: "app.aiDiscoverability.customSubtopics.commuteRow.commuteDisplayFormat",
        defaultMessage: "{minutes} minutes by {transport} to {destination}",
    },
    car: {
        id: "app.aiDiscoverability.customSubtopics.commuteRow.car",
        defaultMessage: "Car",
    },
});
export default messages;
